<div>
  <div class="hero"></div>
  <div>
    <div class="success-container">
      <div>
        <h3>Success</h3>
        <p>Your membership has been successfully changed!</p>
        <p>Thanks for supporting TYT.</p>

        <div class="actions">
            <a mat-raised-button color="primary" routerLink="/settings/memberships">Back to Membership Accounts</a>
        </div>
      </div>
    </div>
  </div>
</div>
